import { useState } from 'react';
import { Container, Col, Card, CardBody, Row } from 'reactstrap';
import { useGetAllUsersQuery } from '../../../reduxToolkit/reducers/usersSlice';
import AjaxSourcedData from '../../formsAndTable/tables/dataTables/dataSource/AjaxSourcedData';
import { getUsersSimpleListTableColumns } from '../../../data/formsAndTable/tables/dataTables/DataSource';
import { useTranslation } from 'react-i18next';
import Breadcrumbs from '../../../coreComponents/breadcrumbs';

const UsetStats = () => {
  const { t } = useTranslation();
  const { data, isFetching, isLoading } = useGetAllUsersQuery({});
  return (
    <>
      <Breadcrumbs
        mainTitle={t('stats.userStats')}
        // parent={t('courses.generalTitle')}
      />
      <Container fluid>
        <Row>
          <Col xl="12" className="box-col-12 proorder-md-1">
            <Card>
              <CardBody className="premium-card">
                <AjaxSourcedData
                  data={data}
                  columns={getUsersSimpleListTableColumns(t)}
                  loading={isLoading || isFetching}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default UsetStats;
